import { CheckNotes, InspectionCase } from '../inspection-cases';

export class Standard_1205_part_1_Dto extends InspectionCase {
  drinkingWaterSystem?: InspectionCase;
  waterPipeInstallationAccordingSpec?: InspectionCase;
  hangingPointsGaps?: InspectionCase;
  verticalTube?: InspectionCase;
  waterSupplyPipesPassage?: InspectionCase;
  sealingConnections?: InspectionCase;
  galvanizedSteelPipes?: InspectionCase;
  corrosionProtectedThread?: InspectionCase;
  plumbingMmadeOfSteel?: InspectionCase;
  galvanizedScrewedUpAbsorbers?: InspectionCase;
  galvanizedSteelPipesAccordingToStandard?: InspectionCase;
  pipeNominalDiameterForSingleFireHydrant?: InspectionCase;
  pipeNominalDiameterForMultiFireHydrants?: InspectionCase;
  pipeNominalDiameterForCartwheel?: InspectionCase;
  fireHydrantIsMarked?: InspectionCase;
  waterSupplyForFireExtinguishing?: InspectionCase;
  drinkingWaterSupplyNetworkConnection?: InspectionCase;
  onlyMetalPipesInstalled?: InspectionCase;
  closingValvesSigns?: InspectionCase;
  fireHydrantExist?: InspectionCase;
  twoHosesExist?: InspectionCase;
  multipurposeJumperExist?: InspectionCase;
  EquipmentApproved?: InspectionCase;
  rubberTube?: InspectionCase;
  multipurposeLeaper?: InspectionCase;
  ballOpeningTap?: InspectionCase;
}

export class Standard_1205_part_1 extends Standard_1205_part_1_Dto {
  constructor(data: Standard_1205_part_1_Dto = { title: 'תקן 1205 חלק 1' }) {
    super(data);
    this.drinkingWaterSystem = new InspectionCase({
      ...data.drinkingWaterSystem,
      title:
        'בחיבור מערכת מי שתייה למערכת אחרת מורכב אמצעי מתאים כגון : אל-חוזר כפול/מז"ח',
      section: '2.1'
    });
    this.waterPipeInstallationAccordingSpec = new InspectionCase({
      ...data.waterPipeInstallationAccordingSpec,
      title: 'צנרת המים הותקנה בהתאם לתקן החל עליה',
      section: '2.2.2.1'
    });
    this.hangingPointsGaps = new InspectionCase({
      ...data.hangingPointsGaps,
      title: `המרווחים בין נקודות התלייה של הצנרת מתאימים לטבלאות 1,2 ו – 3, בהתאם לחומר הצנרת`,
      section: '2..2.8'
    });
    this.verticalTube = new InspectionCase({
      ...data.verticalTube,
      title:
        'בצינור אנכי הותקנו חבקים במרווחים של 3 מטר לכל היותר, ולפחות חבק אחד בכל קומה',
      section: '2.2.8'
    });
    this.waterSupplyPipesPassage = new InspectionCase({
      ...data.waterSupplyPipesPassage,
      title:
        'מעבר צינורות לאספקת מים דרך חלקים יצוקי בטון נעשה דרך פתחים מוכנים מראש או דרך שרוולים',
      section: '2.2.8'
    });

    this.sealingConnections = new InspectionCase({
      ...data.sealingConnections,
      title:
        'איטום החיבורים בין הצינורות והאביזרים בוצע ע"י סיבי פשתן או בעזרת סרט טפלון',
      section: '2.3'
    });
    this.galvanizedSteelPipes = new InspectionCase({
      ...data.galvanizedSteelPipes,
      title: 'בצינורות פלדה מגולוונים לאספקת מים לא בוצעו כיפופים',
      section: '2.3'
    });
    this.corrosionProtectedThread = new InspectionCase({
      ...data.corrosionProtectedThread,
      title: 'מלוא אורך התבריג מוגן מפני קורוזיה',
      section: '2.3'
    });
    this.plumbingMmadeOfSteel = new InspectionCase({
      ...data.plumbingMmadeOfSteel,
      title: `הצנרת עשויה  מפלדה עם ציפוי אבץ או מלט צמנט דרג ב' או סקדיול 40/10`,
      section: '2.3'
    });
    this.galvanizedScrewedUpAbsorbers = new InspectionCase({
      ...data.galvanizedScrewedUpAbsorbers,
      title: 'צינורות בקוטר עד "2 חוברו בעזרת ספחים מתוברגים מגולוונים',
      section: '2.3'
    });
    this.galvanizedSteelPipesAccordingToStandard = new InspectionCase({
      ...data.galvanizedSteelPipesAccordingToStandard,
      title: 'מערכת אספקת מים מורכבת מצינורות פלדה מגולוונים נושאי תו תקן',
      section: '2.3'
    });

    this.pipeNominalDiameterForSingleFireHydrant = new InspectionCase({
      ...data.pipeNominalDiameterForSingleFireHydrant,
      title: 'הקוטר הנומינלי של צינור המספק מים לברז שריפה בודד הינו "2 לפחות',
      section: '3.3'
    });
    this.pipeNominalDiameterForMultiFireHydrants = new InspectionCase({
      ...data.pipeNominalDiameterForMultiFireHydrants,
      title: 'הקוטר הנומינלי של צינור המספק מים למספר ברזי שריפה הינו "3 לפחות',
      section: '3.3'
    });
    this.pipeNominalDiameterForCartwheel = new InspectionCase({
      ...data.pipeNominalDiameterForCartwheel,
      title: 'הקוטר הנומינלי של צינור המספק מים לגלגלון הינו "1 לפחות',
      section: '3.3'
    });
    this.fireHydrantIsMarked = new InspectionCase({
      ...data.fireHydrantIsMarked,
      title: 'ברז כיבוי אש מסומן בתו-תקן',
      section: '3.3'
    });
    this.waterSupplyForFireExtinguishing = new InspectionCase({
      ...data.waterSupplyForFireExtinguishing,
      title: 'אספקת מים לכיבוי אש',
      section: '3.8'
    });
    this.drinkingWaterSupplyNetworkConnection = new InspectionCase({
      ...data.drinkingWaterSupplyNetworkConnection,
      title:
        'אם קיים חיבור בין רשת אספקת מי השתייה לבין מערכת כיבוי אש יותקן אביזר מז"ח כמפורט בסעיף 2.1 לעיל',
      section: '3.8.1'
    });
    this.onlyMetalPipesInstalled = new InspectionCase({
      ...data.onlyMetalPipesInstalled,
      title: 'במערכות כיבוי אש הותקנה צנרת מתכתית בלבד',
      section: '3.8.2'
    });
    this.closingValvesSigns = new InspectionCase({
      ...data.closingValvesSigns,
      title:
        'שסתומי הסגירה ראשיים בצנרת המים לכיבוי אש ישולטו, יצוין מצב פתיחת השסתום',
      section: '3.8.2'
    });

    this.fireHydrantExist = new InspectionCase({
      ...data.fireHydrantExist,
      title: 'ברז כיבוי המתאים לדרישות התקן הישראלי ת"י 448 חלק 1',
      section: '3.8.3'
    });
    this.twoHosesExist = new InspectionCase({
      ...data.twoHosesExist,
      title: 'שני זרנוקים שקוטרם "2 ואורכם 15 מטר המתאימים לתקן ישראלי 365',
      section: '3.8.3'
    });
    this.multipurposeJumperExist = new InspectionCase({
      ...data.multipurposeJumperExist,
      title: 'מזנק רב שימושי שקוטרו "2 עם חצי מצמדת מסוג "שטורץ"',
      section: '3.8.3'
    });
    this.EquipmentApproved = new InspectionCase({
      ...data.EquipmentApproved,
      title: 'כל הציוד הנ"ל יאושר ע"י הרשות המוסמכת',
      section: '3.8.3'
    });
    this.rubberTube = new InspectionCase({
      ...data.rubberTube,
      title: 'צינור גומי שקוטרו "3/4 ואורכו 25 מטר לפחות',
      section: '3.8.3'
    });
    this.multipurposeLeaper = new InspectionCase({
      ...data.multipurposeLeaper,
      title: 'מזנק רב שימושי שקוטרו "1',
      section: '3.8.3'
    });
    this.ballOpeningTap = new InspectionCase({
      ...data.ballOpeningTap,
      title: 'ברז פתיחה כדורי שקוטרו "1',
      section: '3.8.3'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.drinkingWaterSystem.isApplicable ||
        this.drinkingWaterSystem.isPassed) &&
        (!this.waterPipeInstallationAccordingSpec.isApplicable ||
          this.waterPipeInstallationAccordingSpec.isPassed) &&
        (!this.hangingPointsGaps.isApplicable ||
          this.hangingPointsGaps.isPassed) &&
        (!this.sealingConnections.isApplicable ||
          this.sealingConnections.isPassed) &&
        (!this.galvanizedSteelPipes.isApplicable ||
          this.galvanizedSteelPipes.isPassed) &&
        (!this.corrosionProtectedThread.isApplicable ||
          this.corrosionProtectedThread.isPassed) &&
        (!this.plumbingMmadeOfSteel.isApplicable ||
          this.plumbingMmadeOfSteel.isPassed) &&
        (!this.galvanizedScrewedUpAbsorbers.isApplicable ||
          this.galvanizedScrewedUpAbsorbers.isPassed) &&
        (!this.galvanizedSteelPipesAccordingToStandard.isApplicable ||
          this.galvanizedSteelPipesAccordingToStandard.isPassed) &&
        (!this.pipeNominalDiameterForSingleFireHydrant.isApplicable ||
          this.pipeNominalDiameterForSingleFireHydrant.isPassed) &&
        (!this.pipeNominalDiameterForMultiFireHydrants.isApplicable ||
          this.pipeNominalDiameterForMultiFireHydrants.isPassed) &&
        (!this.pipeNominalDiameterForCartwheel.isApplicable ||
          this.pipeNominalDiameterForCartwheel.isPassed) &&
        (!this.fireHydrantIsMarked.isApplicable ||
          this.fireHydrantIsMarked.isPassed) &&
        (!this.waterSupplyForFireExtinguishing.isApplicable ||
          this.waterSupplyForFireExtinguishing.isPassed) &&
        (!this.drinkingWaterSupplyNetworkConnection.isApplicable ||
          this.drinkingWaterSupplyNetworkConnection.isPassed) &&
        (!this.onlyMetalPipesInstalled.isApplicable ||
          this.onlyMetalPipesInstalled.isPassed) &&
        (!this.closingValvesSigns.isApplicable ||
          this.closingValvesSigns.isPassed) &&
        (!this.fireHydrantExist.isApplicable ||
          this.fireHydrantExist.isPassed) &&
        (!this.twoHosesExist.isApplicable || this.twoHosesExist.isPassed) &&
        (!this.multipurposeJumperExist.isApplicable ||
          this.multipurposeJumperExist.isPassed) &&
        (!this.EquipmentApproved.isApplicable ||
          this.EquipmentApproved.isPassed) &&
        (!this.rubberTube.isApplicable || this.rubberTube.isPassed) &&
        (!this.multipurposeLeaper.isApplicable ||
          this.multipurposeLeaper.isPassed) &&
        (!this.ballOpeningTap.isApplicable || this.ballOpeningTap.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.drinkingWaterSystem.getNotes(),
      ...this.waterPipeInstallationAccordingSpec.getNotes(),
      ...this.hangingPointsGaps.getNotes(),
      ...this.sealingConnections.getNotes(),
      ...this.galvanizedSteelPipes.getNotes(),
      ...this.corrosionProtectedThread.getNotes(),
      ...this.plumbingMmadeOfSteel.getNotes(),
      ...this.galvanizedScrewedUpAbsorbers.getNotes(),
      ...this.galvanizedSteelPipesAccordingToStandard.getNotes(),
      ...this.pipeNominalDiameterForSingleFireHydrant.getNotes(),
      ...this.pipeNominalDiameterForMultiFireHydrants.getNotes(),
      ...this.pipeNominalDiameterForCartwheel.getNotes(),
      ...this.fireHydrantIsMarked.getNotes(),
      ...this.waterSupplyForFireExtinguishing.getNotes(),
      ...this.drinkingWaterSupplyNetworkConnection.getNotes(),
      ...this.onlyMetalPipesInstalled.getNotes(),
      ...this.closingValvesSigns.getNotes(),
      ...this.fireHydrantExist.getNotes(),
      ...this.twoHosesExist.getNotes(),
      ...this.multipurposeJumperExist.getNotes(),
      ...this.EquipmentApproved.getNotes(),
      ...this.rubberTube.getNotes(),
      ...this.multipurposeLeaper.getNotes(),
      ...this.ballOpeningTap.getNotes()
    ];
  }
}
